import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import ProjectCard from "./ProjectCards";
import Particle from "../Particle";

import qesem from "../../Assets/Projects/qesem.png";
import geez from "../../Assets/Projects/geez.jpg";
import covid19 from "../../Assets/Projects/covid19.png";
import kana from "../../Assets/Projects/kana.jpg";
import astu from "../../Assets/Projects/astu.jpg";

function Projects() {
  return (
    <Container fluid className="project-section">
      <Particle />
      <Container>
        <h1 className="project-heading">
          My Recent <strong className="purple">Works </strong>
        </h1>
        <p style={{ color: "white" }}>
          Here are a few Public projects I've worked on recently.
        </p>
        <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
          
          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={qesem}
              isBlog={false}
              title="Qesem Acadamy Bot"
              description="This is a bot with library and many school related stuffs in it"
              link="https://t.me/Qesem_OfficialBot"/>
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={covid19}
              isBlog={false}
              title="Ethiopian Covid-19 Tracker"
              description="This is covid tracker"
              link="http://covid19.maedots.com/"/>
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={geez}
              isBlog={false}
              title="Geez Esport comunity Registration Bot"
              description="Tournament Registration bot for geez e-Sport comunity"
              link="https://t.me/GeezEsport_bot"/>
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={kana}
              isBlog={false}
              title="Kana Cinema Bot"
              description="A bot to get movies from kana tv."
              link="https://t.me/Kana_TVbot"/>
          </Col>

          <Col md={4} className="project-card">
            <ProjectCard
              imgPath={astu}
              isBlog={false}
              title="ASTU Courses"
              description="A telegram Bot to provide course details and materials for students."
              link="https://t.me/ASTU_COBOT"/>
          </Col>

        </Row>
      </Container>
    </Container>
  );
}

export default Projects;
